module.exports = __webpack_public_path__ + "static/media/testimonials-1.77f7137f.jpg";